<template>
  <div class="visual-element-video">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        label="Link di Youtube"
        :for-id="`visual-element-video-${_id}`"
        name="Link di Youtube"
        rules="required"
      >
        <v-input
          :id="`visual-element-quote-video-${_id}`"
          type="text"
          name="author"
          v-model="modelDataElement.text"
        /><!-- :value="valueURL"
          @input="decodeURL($event)" -->

        <div class="visual-element-video__error" v-if="error">
          <small class="text-sans-sm font-bold text-error"
            >Inserire un url ad un video di Youtube valido.</small
          >
        </div>
      </FormRow>

      <FormRow
        label="Titolo"
        :for-id="`visual-element-video-title-${_id}`"
        name="Titolo"
        rules="required"
      >
        <v-input
          :id="`visual-element-video-title-${_id}`"
          type="text"
          name="title"
          v-model="modelDataElement.title"
        />
      </FormRow>

      <FormRow
        label="Immagine di anteprima"
        :for-id="`visual-element-video-cover-${_id}`"
        name="Immagine di anteprima"
        rules="required"
      >
        <v-image-input
          :id="`visual-element-link-image-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="508"
          name="src"
          v-model="modelDataElement.src"
          :isVisualElement="true"
        >
          <template v-slot:buttons>
            <button
              type="button"
              class="btn-default ml-4"
              v-if="!isUsingYoutubeThumbnail"
              @click.stop="useYoutubeThumbnail"
            >
              Utilizza anteprima di Youtube
            </button>
          </template>
        </v-image-input>
      </FormRow>
    </FormVisualElement>
  </div>
</template>

<script>
/** Packages */
import getYouTubeID from 'get-youtube-id'

/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'

export default {
  extends: VisualElementBase,

  defaultContent: {
    url: '',
    text: '',
    src: '',
    width: 480,
    height: 360,
    title: '',
  },

  data() {
    return {
      error: false,
    }
  },

  computed: {
    youtubeThumbnailUrl() {
      if (this.modelDataElement.url) {
        return `https://img.youtube.com/vi/${this.modelDataElement.url}/hqdefault.jpg`
      }

      return ''
    },
    isUsingYoutubeThumbnail() {
      return (
        !!this.modelDataElement.src &&
        !!this.youtubeThumbnailUrl &&
        this.modelDataElement.src === this.youtubeThumbnailUrl
      )
    },
  },

  watch: {
    'modelDataElement.text'(newValue) {
      const id = getYouTubeID(newValue)

      if (id) {
        this.$set(this.modelDataElement, 'url', id)
        this.error = false

        if (!this.modelDataElement.src) {
          this.useYoutubeThumbnail()
        }
      } else {
        this.$set(this.modelDataElement, 'url', '')
        this.error = true
      }
    },
  },

  methods: {
    useYoutubeThumbnail() {
      this.modelDataElement.src = this.youtubeThumbnailUrl
    },
  },
}
</script>
